import { Alert, Avatar, Badge, Button, Card, Checkbox, Col, Drawer, Dropdown, Flex, Input, List, Modal, Popconfirm, Row, Skeleton, Tag, Tooltip, Typography, notification, theme } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import {
    DeleteOutlined,
    EyeOutlined,
    DownloadOutlined,
    EditOutlined,
    MoreOutlined,
    FileTextOutlined,
    LikeOutlined,
    DislikeOutlined,
    HistoryOutlined,
    SignatureOutlined,
    SearchOutlined,
    UnorderedListOutlined,
    CopyOutlined,
    FilePdfOutlined,
    CommentOutlined,
    RollbackOutlined
} from '@ant-design/icons';
import AddAgendaItem from './AddAgendaItem';
import { useDispatch, useSelector } from 'react-redux';
import { agendaCapture, agendaReplace, screenStart } from '../../redux/slices/meetingSlice';
import MeetingAPI from '../../restAPI/MeetingAPI';
import AnnotationAPI from '../../restAPI/AnnotationAPI';
import { getAnnotationStatusProps } from '../../utils/annotationUtils';
import AnnotationModal from '../../components/AnnotationModal';
import dayjs from 'dayjs';
import ShareList from './E-SignatureShareList';
import PDFSignature from './PdfSignature';
import SingleVoteRender from './HandleVoting';
import MeetingMinute from './components/MeetingMinute';
import ShareForwordPaper from './Share-ForwordPaper';
import CommonSkeletonLoader from '../CommonSkeleton';
import { ROLE } from '../../utils/enum';


const { Text } = Typography;

export default function AgendaItem(props) {
    const agendaScreenRef = useRef();
    const shareForwardScreenRef = useRef();
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [PDFData, setPDFData] = useState({
        agendaID: "",
        itemId: "",
        attachmentId: "",
        fileName: "",
        userDetailId: ""
    });

    const { companyId, token, role, userCompany } = useSelector(state => state.auth);
    const { agendaID, agenda, actionState, agendas, meetingCommonInfo, committee } = useSelector(state => state.meeting);
    const { token: {
        colorBgContainer,
        colorBgSpotlight,
        colorPrimaryBorder,
        colorTextDescription,
        colorText,
        colorTextHeading,
        fontSizeSM,
        colorBgElevated,
        borderRadiusLG,
        colorBorder,
        colorTextPlaceholder,
        colorPrimary,
        colorWarning,
        colorBgLayout,
        colorError },
    } = theme.useToken();
    const [setAvatarColor] = useState(colorTextPlaceholder);

    const nameCardContainerStyle = {
        marginTop: 8,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        borderRadius: borderRadiusLG,
        backgroundColor: colorBgContainer,
        cursor: 'pointer',
    };

    const avatarStyle = {
        backgroundColor: colorPrimaryBorder,
        color: colorPrimary,
        marginLeft: 8
    };

    const chatSummeryStyle = {
        fontSize: fontSizeSM,
        color: colorTextDescription,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '230px',
        display: 'inline-block'
    };

    const checkBoxStyle = {
        marginLeft: 8,
        marginRight: 8
    };

    const handleClick = () => {
        setAvatarColor(prevColor => prevColor === colorTextPlaceholder ? colorPrimary : colorTextPlaceholder);
    };
    const [isAgendaScreenLoading, setIsAgendaScreenLoading] = useState(false)
    const [openAddNewAgendaDrawer, setOpenAddNewAgendaDrawer] = useState(false);
    const [openMemberListForSignature, setOpenMemberListForSignature] = useState(false);
    const [agendaItemOpenState, setAgendaItemOpenState] = useState('add')
    const [attachement, setAttachement] = useState([]);
    const [allowVoting, setAllowVoting] = useState(false);
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({})
    const [selectedPaperItemID, setSelectedPaperItemID] = useState(null);
    const [selectedAttachmentID, setSelectedAttachmentID] = useState(null);
    const [showVoteResult, setShowVoteResult] = useState(false);
    const [selectedPaper, setSelectedPaper] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [signatureList, setSignatureList] = useState([])
    const [votingData, setVotingData] = useState({
        isEnabled: false,
        end: {
            type: 'after',
            customDate: null,
            customTime: null
        }
    });
    const [documentArray, setDocumentArray] = useState([]);
    const [signatureInviteList, setSignatureInviteList] = useState([])
    const [dropdownVisible, setDropdownVisible] = useState({});

    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null)
    const [selectedPaperItemIndex, setSelectedPaperItemIndex] = useState(null)
    const [selectedAttachmentIndex, setSelectedAttachmentIndex] = useState(null)
    const [draggedPaperItemIndex, setDraggedPaperItemIndex] = useState(null);
    const [draggedCategoryIndex, setDraggedCategoryIndex] = useState(null);
    const [dropTargetIndex, setDropTargetIndex] = useState(null);
    const [draggedOverCategoryIndex, setDraggedOverCategoryIndex] = useState(null);
    const [draggedOverPaperItemIndex, setDraggedOverPaperItemIndex] = useState(null);
    const [selectedTagToMove, setSelectedTagToMove] = useState(null)
    const [openShareForwardDrawer, setOpenShareForwardDrawer] = useState(false);
    const [clickedItemType, setClickedItemType] = useState(null);
    const [selectedItemToSend, setSelectedItemToSend] = useState(null)
    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"))
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeysToSendMeeting, setSelectedKeysToSendMeeting] = useState(null);
    const [isLayer1Visible, setIsLayer1Visible] = useState(true);
    const [shareForwardDrawerLoading, setShareForwardDrawerLoading] = useState(true);
    const [isLoadingWhileSending, setIsLoadingWhileSending] = useState(false)
    const [documentOpenState, setDocumentOpenState] = useState('add');
    const [isAddDisable, setIsAddDisable] = useState(true);
    const [uploadFileDetails, setUploadFileDetails] = useState(null);
    const [annotationModalVisible, setAnnotationModalVisible] = useState(false);
    const [currentAnnotationUrl, setCurrentAnnotationUrl] = useState(null);
    const [currentAnnotationTitle, setCurrentAnnotationTitle] = useState("PDF Annotation");

    const [api, contextHolder] = notification.useNotification();

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    useEffect(() => {
        const companyInfo = userCompany.companyData.find(company => company.companyId == companyId);
        setCurrentCompanyInfo(companyInfo);
    }, [companyId])

    const handleDropdownVisibleChange = (visible, paperId) => {
        setDropdownVisible((prev) => ({
            ...prev,
            [paperId]: visible
        }))
    };

    const handlePopconfirmOpen = (e) => {
        e.stopPropagation();
    };

    const handlePopconfirmClose = (paperId) => {
        setDropdownVisible((prev) => ({
            ...prev,
            [paperId]: false
        }))
    };

    const getUpdateVotingResults = async (paperId) => {
        try {
            const response = await MeetingAPI.getUpdatedPaperItemDetails(agendaID, paperId, companyId, token);
            if (response.status === 200) {
                const changedValue = {
                    ...response.data.data,
                    attachments: response?.data?.data?.attachments.map((attachment) => {
                        if (attachment?.voting?.isEnabled && attachment?.voting?.end?.type === 'custom') {
                            const { date } = attachment?.voting?.end;
                            return {
                                ...attachment,
                                voting: {
                                    ...attachment.voting,
                                    end: {
                                        ...attachment.voting.end,
                                        customDate: date,
                                        date: undefined
                                    }
                                }
                            }
                        } else {
                            return attachment;
                        }
                    })
                }
                const votedAttachmentFromTheList = {
                    ...props.addedPapersList,
                    categories: props.addedPapersList?.categories.map((category) => ({
                        ...category,
                        items: category?.items.map((item) =>
                            item._id === changedValue._id ? {
                                ...item,
                                attachments: item.attachments.map((attachment) => {
                                    const updatedAttachment = changedValue?.attachments.find(updated => updated._id === attachment._id);
                                    return updatedAttachment ? {
                                        ...attachment,
                                        voting: updatedAttachment?.voting
                                    } : attachment
                                })
                            } : item)
                    }))
                }
                props.setRefreshAgendaItemsList(false);
                props.setAddedPapersList(votedAttachmentFromTheList)
                dispatch(agendaReplace(votedAttachmentFromTheList))
            }
        } catch (error) {
            props.setRefreshAgendaItemsList(false);
            console.log('error :', error)
            openNotificationWithIcon('error', 'Error', 'Something went wrong while fetching update votes.', 'bottomLeft');
        }
        return null;
    }

    const handlePaperVote = async (votedAttachment, voteType, selectedCategoryId, singleItemId) => {
        const votePayload = {
            itemId: singleItemId,
            attachmentId: votedAttachment._id,
            originalUserDetailsId: meetingCommonInfo.originalUserDetailsId,
            vote: voteType,
        }
        try {
            props.setRefreshAgendaItemsList(true);
            const response = await MeetingAPI.updateAgendaVoteById(agendaID, votePayload, companyId, token);
            if (response.status === 200) {
                setTimeout(async () => {
                    await getUpdateVotingResults(singleItemId)
                }, 500)
            }
        } catch (error) {
            props.setRefreshAgendaItemsList(false);
            console.log('Error in handle paper vote :', error)
            const errorMessage = error?.response?.data?.message || 'Document voting failed.';
            openNotificationWithIcon('error', 'Failed', errorMessage, 'bottomLeft');
        }
    };

    const options = (doc, categoryId, singleItemId) => ({
        items: [
            {
                key: 'approve',
                icon: <LikeOutlined />,
                label: <a onClick={() => handlePaperVote(doc, 'approve', categoryId, singleItemId)}>Accept</a>,
            },
            {
                key: 'abstain',
                icon: <HistoryOutlined />,
                label: <a onClick={() => handlePaperVote(doc, 'abstain', categoryId, singleItemId)}>Abstain</a>,
            },
            {
                key: 'reject',
                icon: <DislikeOutlined />,
                label: <a onClick={() => handlePaperVote(doc, 'reject', categoryId, singleItemId)}>Reject</a>,
            },
        ],
    });

    const handleViewAddedPaper = (categoryIndex, docIndex) => {
        const selectedCategory = props.addedPapersList.categories.find(category => category._id === categoryIndex)
        if (selectedCategory) {
            const selectedPaper = selectedCategory.items.find(paper => paper._id === docIndex);
            setSelectedCategory(selectedCategory)
            setSelectedPaper(selectedPaper)
            setAgendaItemOpenState('view')
            showDrawer();
        }
    }

    const handleEditAddedPaper = (categoryIndex, singleDoc) => {
        const selectedCategory = props.addedPapersList.categories.find(category => category._id === categoryIndex)
        if (selectedCategory) {
            const selectedPaper = selectedCategory.items.find(paper => (paper.isAddedToDB ? paper._id : paper.id) === (singleDoc.isAddedToDB ? singleDoc._id : singleDoc.id));
            setSelectedPaper(selectedPaper)
            setSelectedCategory(selectedCategory)
            setAgendaItemOpenState('edit')
            showDrawer();
        }
    }

    const handleRemoveAddedPaper = (categoryIndex, singleDoc) => {
        const selectedCategory = props.addedPapersList.categories.find(category => category._id === categoryIndex)
        if (selectedCategory) {
            const filteredItemsList = selectedCategory.items.filter(item => (item.isAddedToDB ? item._id : item.id) !== (singleDoc.isAddedToDB ? singleDoc._id : singleDoc.id))
            if (filteredItemsList?.length > 0) {
                const updatedCategories = props.addedPapersList.categories.map((category) =>
                    category._id === categoryIndex
                        ? { ...category, items: filteredItemsList }
                        : category)
                const updatedAgenda = { ...agenda, categories: updatedCategories };

                props.setAddedPapersList(updatedAgenda)
                dispatch(agendaReplace(updatedAgenda))
            } else {
                // here we need to remove the whole category, because there is no any items left.
                const remainginAgenda = props.addedPapersList.categories.filter(category => category._id !== categoryIndex)
                const updatedAgenda = { ...agenda, categories: remainginAgenda };

                props.setAddedPapersList(updatedAgenda)
                props.setTempAddedPapersList(updatedAgenda)
                dispatch(agendaReplace(updatedAgenda))
            }
        }
    }

    const getItems = (categoryIndex, docIndex, singleDoc, category) => [
        {
            label: (<a rel="noopener noreferrer" onClick={() => handleViewAddedPaper(categoryIndex, docIndex)}> View </a>),
            key: '0',
            icon: <EyeOutlined />
        },
        actionState !== 'view' && {
            label: (<a rel="noopener noreferrer" onClick={() => handleEditAddedPaper(categoryIndex, singleDoc)}> Edit </a>),
            key: '1',
            icon: <EditOutlined />
        },
        actionState === 'editPaper' && {
            label: (<a rel="noopener noreferrer" onClick={() => showCopyForwardDrawer(singleDoc, 'paperItem')}>Copy & Forward  </a>),
            key: '2',
            icon: <EditOutlined />
        },
        actionState !== 'view' && {
            label: (
                <Popconfirm
                    title="Do you want to remove the paper item?"
                    onConfirm={() => {
                        handleRemoveAddedPaper(categoryIndex, singleDoc);
                        handlePopconfirmClose(docIndex);
                    }}
                    onCancel={() => {
                        openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft');
                        handlePopconfirmClose(docIndex);
                    }
                    }
                    okText="Yes"
                    cancelText="No"
                >
                    <a rel="noopener noreferrer"
                        // onClick={() => handleRemoveAddedPaper(docIndex)}
                        onClick={(e) => handlePopconfirmOpen(e)}
                    > Delete </a>
                </Popconfirm>
            ),
            key: '3',
            icon: <DeleteOutlined />,
            danger: true
        },
    ]

    const handlePDFAnnotation = (doc) => {
        console.log('doc :', doc)
        // Check if annotation system is enabled
        if (!AnnotationAPI.isEnabled()) {
            openNotificationWithIcon('warning', 'Annotation System Disabled', 'PDF annotation is not available.', 'bottomLeft');
            return;
        }

        let annotationUrl = null;

        // Check if this is an annotation URL (starts with /pdf/session/)
        if (doc.file && doc.file.startsWith('/pdf/session/')) {
            // This is a relative annotation URL, append the frontend URL
            const annotationFrontendUrl = AnnotationAPI.getFrontendUrl();
            annotationUrl = `${annotationFrontendUrl}${doc.file}`;
            console.log('Opening annotation URL in modal:', annotationUrl);
        }
        // Check if this is already a full annotation URL (starts with http)
        else if (doc.file && (doc.file.startsWith('http://') || doc.file.startsWith('https://'))) {
            // This is already a full annotation URL
            annotationUrl = doc.file;
            console.log('Opening full annotation URL in modal:', annotationUrl);
        }
        // For local files, we need to upload to annotation system first
        else {
            // This should not happen in normal flow since files are uploaded to annotation system first
            openNotificationWithIcon('error', 'Annotation Error', 'This file is not available for annotation.', 'bottomLeft');
            return;
        }

        // Open annotation in modal instead of new window
        if (annotationUrl) {
            setCurrentAnnotationUrl(annotationUrl);
            setCurrentAnnotationTitle(doc.name || doc.documentName || doc.fileName || "PDF Annotation");
            setAnnotationModalVisible(true);
        }
    };

    // const attachmentOptions = (doc, paperId, categoryId) => {
    //     return [
    //       actionState === "view" && {
    //         label: (
    //           <a onClick={() => handlePDFAnnotation(doc)}>
    //             {/* PDF-annotation */}
    //             {dayjs(meetingCommonInfo?.meetingdateAndTime).isBefore(dayjs())
    //               ? "View PDF"
    //               : "PDF-annotation"}
    //           </a>
    //         ),
    //         key: "0",
    //         icon: <SignatureOutlined />,
    //       },
    //     //   removed - bug 13233
    //     //   actionState === "view" && {
    //     //     label: (
    //     //       <a onClick={() => handlePaperItemDownload(doc, paperId)}>
    //     //         Download
    //     //       </a>
    //     //     ),
    //     //     key: "1",
    //     //     icon: <DownloadOutlined />,
    //     //   },
    //       (actionState === "view" ||
    //         (actionState === "editPaper" &&
    //           mapESignatureData(doc).length > 0)) &&
    //         (role.some((r) => r.roleName === "Secretary") ||
    //           role.some((r) => r.roleName === "Assistant Secretary")) && {
    //           label: (
    //             <a onClick={() => openNotification(doc)}>
    //               e-Signature Sent List //e-Signatures
    //             </a>
    //           ),
    //           key: "2",
    //           icon: <UnorderedListOutlined />,
    //         },
    //       ["editPaper"].includes(actionState) && {
    //         label: (
    //           <a
    //             onClick={() => {
    //               setSelectedPaperItemID(paperId);
    //               setSelectedAttachmentID(doc.isAddedToDB ? doc._id : doc.id);
    //               setSelectedCategory(categoryId);
    //               showMemberListDrawer(doc, paperId);
    //             }}
    //           >
    //             Request e-Signature
    //           </a>
    //         ),
    //         key: "3",
    //         icon: <UnorderedListOutlined />,
    //       },
    //       actionState === "editPaper" &&
    //         (doc?.shareWith?.type === 'all') &&
    //         (role.some((r) => r.roleName === "Secretary") ||
    //           role.some((r) => r.roleName === "Assistant Secretary")) && {
    //           label: (
    //             <a onClick={() => showCopyForwardDrawer(doc, "attachment")}>
    //               Copy & Forward{" "}
    //             </a>
    //           ),
    //           key: "5",
    //           icon: <UnorderedListOutlined />,
    //         },
    //     ].filter(Boolean); // Filter out any undefined or falsy values
    // };

    const handlePaperItemDownload = async (doc, paperId) => {
        const downloadAttachmentPayload = {
            itemId: paperId,
            attachmentId: doc._id,
            filePath: doc.file
        }

        try {
            const response = await MeetingAPI.downloadPaperItemSingleAttachment(agendaID, downloadAttachmentPayload, companyId, token);
            if (response.status === 200) {
                const fileType = response.headers['content-type'];

                const validTypes = [
                    'application/pdf', // PDF files
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',  // .xlsx
                    'application/msword',  // .doc
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
                    'text/csv',  // .csv
                    'application/vnd.ms-powerpoint',  // .ppt
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',  // .pptx
                ];

                if (!validTypes.includes(fileType)) {
                    openNotificationWithIcon('error', 'Abort', `Unsupported file type. Cannot download this file.`, 'bottomLeft')
                    return;
                }

                const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
                const link = document.createElement('a');
                link.href = url;

                let fileExtension;
                if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    fileExtension = 'xlsx';
                } else if (fileType === 'application/msword') {
                    fileExtension = 'doc';
                } else if (fileType === 'text/csv') {
                    fileExtension = 'csv';
                } else if (fileType === 'application/vnd.ms-powerpoint') {
                    fileExtension = 'ppt';
                } else if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                    fileExtension = 'docx';
                } else if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                    fileExtension = 'pptx';
                } else if (fileType.includes('/')) {
                    fileExtension = fileType.split('/')[1];
                } else {
                    fileExtension = 'file';
                }

                const originalName = doc.fileName || `downloaded_file.${fileExtension}`;
                const baseName = originalName.replace(/\.[^/.]+$/, ''); // removes extension
                const fileName = `${baseName}.${fileExtension}`;

                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log('Error in single attachment download :', error);
            openNotificationWithIcon('error', 'Abort', `Single attachment download failed.`, 'bottomLeft')
        }
    }

    const handleAddPapersButton = () => {
        setAgendaItemOpenState('add')
        showDrawer();
    }

    const showDrawer = () => {
        setOpenAddNewAgendaDrawer(true);
    };
    const onClose = () => {
        setVotingData({
            isEnabled: false,
            end: {
                type: 'after',
                customDate: null,
                customTime: null
            }
        });
        setDocumentArray([]);

        if (agendaScreenRef.current) {
            agendaScreenRef.current.resetFormFields();
        }
        setOpenAddNewAgendaDrawer(false);
        setSelectedCategory({})
        setSelectedPaper(null)
        setDocumentOpenState('add');
        setIsAddDisable(true)
        setUploadFileDetails(null);
    };

    const showMemberListDrawer = (doc, paperId) => {
        setOpenMemberListForSignature(true);
    };
    const onCloseMemberListDrawer = () => {
        setOpenMemberListForSignature(false);
        setSignatureInviteList([]);
        setSelectedAttachmentID(null);
        setSelectedPaperItemID(null);
    };

    const handleAgendaItemSave = async () => {
        try {
            const values = await agendaScreenRef.current.validateAndRetrieveData();
            dispatch(screenStart());

            const { paperCategory, paperName, paperCode, paperNo, comment, paperStatus } = values;

            if (agendaItemOpenState === 'add') {
                const randomId = Math.random().toString(36).substr(2, 9);
                if (agenda?.categories?.length === 0) {
                    const newAgendaItem = {
                        _id: agendaID ? agendaID : null,
                        categories: [{
                            _id: paperCategory.value,
                            id: paperCategory.value,
                            isAddedToDB: false,
                            order: 1,
                            categoryName: paperCategory.label,
                            items: [{
                                _id: null,
                                id: randomId,
                                isAddedToDB: false,
                                name: paperName,
                                order: paperNo,
                                code: paperCode ? paperCode : null,
                                comment: comment ? comment : null,
                                attachments: documentArray,
                                status: paperStatus,
                            }]
                        }],
                    };
                    openNotificationWithIcon('success', 'Successful', `Paper item added successfully.`, 'bottomLeft');

                    dispatch(agendaCapture(newAgendaItem));
                    props.setAddedPapersList(newAgendaItem)
                    props.setTempAddedPapersList(newAgendaItem)
                } else {
                    // console.log('NOT first', documentArray)
                    let categoryExist = false;

                    const updatedCategories = agenda.categories.map((category) => {
                        if (category._id === paperCategory.value) {
                            categoryExist = true;
                            return {
                                ...category,
                                items: [
                                    ...category.items,
                                    {
                                        _id: null,
                                        id: randomId,
                                        isAddedToDB: false,
                                        name: paperName,
                                        order: paperNo,
                                        code: paperCode,
                                        comment: comment || null,
                                        attachments: documentArray,
                                        status: paperStatus,
                                    },
                                ],
                            };
                        }
                        return category;
                    })

                    if (!categoryExist) {
                        const newCategory = {
                            id: paperCategory.value,
                            _id: paperCategory.value,
                            order: updatedCategories.length + 1,
                            categoryName: paperCategory.label,
                            isAddedToDB: false,
                            items: [
                                {
                                    _id: null,
                                    id: randomId,
                                    isAddedToDB: false,
                                    name: paperName,
                                    order: paperNo,
                                    code: paperCode ? paperCode : null,
                                    comment: comment || null,
                                    attachments: documentArray,
                                    status: paperStatus,
                                    isAddedToDB: false
                                }
                            ]
                        }
                        updatedCategories.push(newCategory)
                    }
                    const updatedAgenda = {
                        ...agenda,
                        categories: updatedCategories
                    }
                    openNotificationWithIcon('success', 'Successful', `Paper item added successfully.`, 'bottomLeft');

                    dispatch(agendaReplace(updatedAgenda));
                    props.setAddedPapersList(updatedAgenda);
                    props.setTempAddedPapersList(updatedAgenda)
                }
                // props.setAddedPapersList(prev => [...prev, { ...newAgendaItem }])
            } else if (agendaItemOpenState === 'edit' && actionState === 'add') {
                // console.log('second')
                const paperIndex = agendas.findIndex(item =>
                    item.paperId.trim() === selectedPaper.paperId.trim()
                )

                const updatedAgendaItem = {
                    paperId: selectedPaper.paperId,
                    categoryId: paperCategory.value,
                    categoryName: paperCategory.label,
                    name: paperName,
                    order: paperNo,
                    code: paperCode,
                    comment: comment,
                    status: paperStatus,
                    isAddedToDB: false,
                    attachments: documentArray,
                    _id: null
                };

                if (paperIndex !== -1) {
                    const updatedAgendas = agendas.map((item, index) =>
                        index === paperIndex ? updatedAgendaItem : item
                    );
                    openNotificationWithIcon('success', 'Successful', `Paper item edited successfully.`, 'bottomLeft');

                    dispatch(agendaReplace(updatedAgendas));
                    props.setAddedPapersList(updatedAgendas);
                    props.setTempAddedPapersList(updatedAgendas)
                } else {
                    openNotificationWithIcon('error', 'Update Failed', `Paper item edit failed.`, 'bottomLeft');
                }
            } else if (agendaItemOpenState === 'edit' && actionState === 'editPaper') {
                // console.log('third')
                const tempSelectedCategory = agenda.categories.find(category => category._id === (selectedCategory.isAddedToDB ? selectedCategory.categoryId : selectedCategory._id))

                let paperIndex = null;
                if (selectedCategory) {
                    paperIndex = selectedCategory.items.findIndex(item => ((item.isAddedToDB ? item._id : item.id) === (selectedPaper.isAddedToDB ? selectedPaper._id : selectedPaper.id)));
                }

                const attachments = selectedPaper.attachments || [];

                const updatedDocumentArray = documentArray.map(document => {
                    const matchingAttachment = attachments.find(attachment => (attachment.isAddedToDB ? attachment._id : attachment.id) === (document.isAddedToDB ? document._id : document.id));
                    return {
                        ...document,
                        eSignature: matchingAttachment?.eSignature || { members: [] },
                    };
                });

                const updatedPaperItem = {
                    _id: selectedPaper._id,
                    id: selectedPaper.id,
                    name: paperName,
                    order: paperNo,
                    code: paperCode,
                    comment: comment ? comment : null,
                    attachments: updatedDocumentArray,
                    status: paperStatus,
                    isAddedToDB: selectedPaper.isAddedToDB
                }

                if (paperIndex !== -1) {
                    const updatedItemsArray = tempSelectedCategory.items.map(item =>
                        (item.isAddedToDB ? item._id : item.id) === (selectedPaper.isAddedToDB ? selectedPaper._id : selectedPaper.id)
                            ? updatedPaperItem
                            : item
                    );

                    const updatedTempSelectedCategory = {
                        ...tempSelectedCategory,
                        items: updatedItemsArray
                    }
                    const updatedCategoriesArray = agenda.categories.map(category =>
                        category._id === updatedTempSelectedCategory._id ? updatedTempSelectedCategory : category
                    )
                    const updatedAgenda = { ...agenda, categories: updatedCategoriesArray }
                    openNotificationWithIcon('success', 'Successful', `Paper item edited successfully.`, 'bottomLeft');

                    dispatch(agendaReplace(updatedAgenda));
                    props.setAddedPapersList(updatedAgenda);
                    props.setTempAddedPapersList(updatedAgenda)
                } else {
                    openNotificationWithIcon('error', 'Update Failed', `Paper item edit failed.`, 'bottomLeft');
                }
            }

            agendaScreenRef.current.resetFormFields();
            onClose();
        } catch (error) {
            console.log("Error in saving agenda item:", error);
        }
    };

    const handleSignatureListSave = () => {
        const selectedCategoryData = agenda.categories.find(category => category._id === selectedCategory)
        if (selectedCategoryData) {
            const selectedPaperItemDetails = selectedCategoryData.items.find(single => (single.isAddedToDB ? single._id : single.id) === selectedPaperItemID)
            const { attachments } = selectedPaperItemDetails;
            const selectedAttachmentArray = attachments?.find(single => (single.isAddedToDB ? single._id : single.id) === selectedAttachmentID)

            const updatedAttachment = {
                ...selectedAttachmentArray,
                eSignature: {
                    members: signatureInviteList
                }
            }

            const updatedAttachments = attachments.map((attachment) =>
                attachment.id === selectedAttachmentArray.id
                    ? updatedAttachment
                    : attachment
            );
            const updatedItems = selectedCategoryData.items.map((item) =>
                (item.isAddedToDB ? item._id : item.id) === selectedPaperItemID
                    ? { ...item, attachments: updatedAttachments }
                    : item
            );
            const updatedCategories = agenda.categories.map((category) =>
                (category.isAddedToDB ? category.id : category._id) === selectedCategory
                    ? { ...category, items: updatedItems }
                    : category
            );
            const updatedAgenda = { ...agenda, categories: updatedCategories };
            dispatch(agendaReplace(updatedAgenda))
            props.setAddedPapersList(updatedAgenda)
            onCloseMemberListDrawer()
        }
    }

    const renderVotedIcon = (doc) => {
        const isEnabled = doc?.voting?.isEnabled ?? false;
        const votes = doc?.voting?.votes || [];

        const hasVoted = votes.find(vote => vote.originalUserDetailsId === currentCompanyInfo.userDetailsId);

        return (
            <>
                <Badge
                    count={
                        hasVoted == null
                            ? null
                            : isEnabled && votes?.length > 0
                                ? hasVoted.type === "approve"
                                    ? <Avatar size={24} icon={<LikeOutlined />} style={{ backgroundColor: colorPrimary }} />
                                    : hasVoted.type === "reject"
                                        ? <Avatar size={24} icon={<DislikeOutlined />} style={{ backgroundColor: colorError }} />
                                        : <Avatar size={24} icon={<HistoryOutlined />} style={{ backgroundColor: colorWarning }} />
                                : null
                    }
                    // <Avatar size={24} icon={<HistoryOutlined />} style={{ backgroundColor: colorWarning }} />
                    // count={<Avatar size={24} icon={<DislikeOutlined />} style={{ backgroundColor: colorError }} />}
                    offset={[-8, 40]}
                >
                    <Avatar size={48} icon={<FileTextOutlined />} />
                </Badge>
            </>
        )
    }

    const renderAnnotationStatus = (doc) => {
        const statusProps = getAnnotationStatusProps(doc);
        if (!statusProps) return null;

        return (
            <Tag color={statusProps.color} icon={<EditOutlined />} style={{ margin: 0 }}>
                {statusProps.children}
            </Tag>
        );
    };

    const getAnnotationCount = (annotation, type) => annotation?.find((single) => single.type === type)?.count || 0;

    
    const renderAnnotationCounts = (annotation) => {
        const commentCount = getAnnotationCount(annotation, 'comment');
        const replyCount = getAnnotationCount(annotation, 'reply');

        if (!commentCount && !replyCount) return null;

        return (
            <Flex align='center' gap={6}>
                {commentCount > 0 && (
                    <Tooltip title={`${commentCount} comment${commentCount === 1 ? '' : 's'}`}>
                        <Tag icon={<CommentOutlined />} bordered={false} style={{ margin: 0 }}>
                            {commentCount}
                        </Tag>
                    </Tooltip>
                )}
                {replyCount > 0 && (
                    <Tooltip title={`${replyCount} repl${replyCount === 1 ? 'y' : 'ies'}`}>
                        <Tag icon={<RollbackOutlined />} bordered={false} style={{ margin: 0 }}>
                            {replyCount}
                        </Tag>
                    </Tooltip>
                )}
            </Flex>
        );
    };

    const handleOpenModal = () => setIsModalVisible(true);
    const handleCloseModal = () => setIsModalVisible(false);

    const renderIncommingSignatureRequest = (doc, itemId) => {
        if (actionState === 'view') {
            const isAvailableToAddSignature = meetingCommonInfo?.meetingStatus !== 'archive' && doc.signatureRequestList.some(
                (single) =>
                    single.userDetailsId == currentCompanyInfo.userDetailsId &&
                    single.isRequested
                    && !single.isAccepted
            );

            setSignatureList(doc.signatureRequestList)
            if (isAvailableToAddSignature) {
                return (
                    <>
                        <Alert
                            message="Please Add your e-Signature to this document"
                            type="warning"
                            showIcon
                            action={
                                <Button size="small" type="text" onClick={() => {
                                    setPDFData({
                                        'agendaId': agendaID,
                                        'itemId': itemId,
                                        'fileName': doc.file,
                                        'attachmentId': doc._id,
                                        'userDetailId': currentCompanyInfo.userDetailsId
                                    })
                                    handleOpenModal();
                                }}>
                                    Add
                                </Button>
                                // When user click Add button redirect to PDF viewer that can add a signature
                            }
                            closable
                        />
                        <Modal
                            title="Sign Document"
                            visible={isModalVisible}
                            footer={null} // Custom footer handled in PDFViewer
                            onCancel={handleCloseModal}
                            width={768}
                        >
                            <PDFSignature
                                signatureList={signatureList}
                                agendaID={PDFData.agendaId}
                                itemId={PDFData.itemId}
                                attachmentId={PDFData.attachmentId}
                                fileName={PDFData.fileName}
                                userDetailId={PDFData.userDetailId}
                                token={token}
                                companyId={companyId}
                                onClose={handleCloseModal}
                                closeOnSuccess={props.closeDrawer}
                                callbackfunpdf={props.callbackfun}
                            />
                        </Modal>
                    </>
                )
            }
        }
    }

    useEffect(() => {
        setVotingData(prev => ({
            ...prev,
            isEnabled: allowVoting
        }));
    }, [allowVoting]);


    // used to filter published papers and documents to none secretary / assistant secretary users
    useEffect(() => {
        const { categories } = agenda;
        
        if ( !((categories ?? []).length > 0) ) return;
        
            const filteredAgenda = (role.some(r => r.roleName === ROLE.SECRETARY || r.roleName === ROLE.ASSISTANT_SECRETARY))
                ? {
                    _id: agenda._id,
                    categories: categories
                        .map(category => {
                            return {
                                ...category,
                                items: category.items
                                    .map(item => {
                                        return {
                                            ...item,
                                            attachments: item.attachments.map(attachment => {
                                                if (attachment.voting.isEnabled && attachment.voting.end.type === 'custom') {
                                                    const { date } = attachment.voting.end;
                                                    const updatedAttachment = {
                                                        ...attachment,
                                                        voting: {
                                                            ...attachment.voting,
                                                            end: {
                                                                ...attachment.voting.end,
                                                                customDate: date
                                                            }
                                                        }
                                                    };
                                                    delete updatedAttachment.voting.end.date;  // Remove `end.date`
                                                    return updatedAttachment;
                                                }
                                                return attachment;
                                            })
                                        };
                                    })
                            };
                        })
                        .filter(category => {
                            return category.items.length > 0;
                        })
                }
                : {
                    _id: agenda._id,
                    categories: categories
                        .map(category => {
                            return {
                                ...category,
                                items: category.items
                                    .filter(item => item.status === 'published')
                                    .map(item => {
                                        return {
                                            ...item,
                                            attachments: item.attachments.map(attachment => {
                                                if (attachment.voting.isEnabled && attachment.voting.end.type === 'custom') {
                                                    const { date } = attachment.voting.end;
                                                    return {
                                                        ...attachment,
                                                        voting: {
                                                            ...attachment.voting,
                                                            end: {
                                                                ...attachment.voting.end,
                                                                customDate: date,
                                                                date: undefined
                                                            }
                                                        }
                                                    };
                                                }
                                                return attachment;
                                            })
                                        };
                                    })
                            };
                        })
                        .filter(category => {
                            return category.items.length > 0;
                        })
                }

            props.setAddedPapersList(filteredAgenda);
            props.setTempAddedPapersList(filteredAgenda);

    }, []);

    const mapESignatureData = (doc) => {
        const signatureRequestList = doc?.signatureRequestList ?? [];
        const members = committee?.participant?.members ?? [];
        const eSignatureData = signatureRequestList
            .filter((signature) => signature?.isRequested)
            .map((signature) => {
                const member = members.find(
                    (member) => member?.userDetailsId === signature?.userDetailsId
                );

                return {
                    user: member ? member.name : 'Unknown User',
                    status: signature.isAccepted ? 'Accept' : 'Sent',
                };
            });

        return eSignatureData;
    };
    const rendereSignatureList = (doc) => {
        const eSignatureData = mapESignatureData(doc);

        return (
            <List
                dataSource={eSignatureData}
                renderItem={(item, index) => (
                    <List.Item key={index}>
                        <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                            <Text>{item.user}</Text>
                            <Tag color={item.status === 'Accept' ? 'green' : 'red'}>{item.status}</Tag>
                        </Flex>
                    </List.Item>
                )}
            />
        )
    };

    const openNotification = (doc) => {
        props.setOpenNotificationForEsignatureList(true)
        api.open({
            message: 'e-Signatures',
            description: rendereSignatureList(doc),
            duration: 0,
            placement: 'bottomLeft',
            onClose: () => props.setOpenNotificationForEsignatureList(false)
        });
    };

    const [openESignatureList, setOpenESignatureList] = useState(false);
    const showDrawerESignatureList = () => {
        setOpenESignatureList(true);
    };
    const onCloseESignatureList = () => {
        setOpenESignatureList(false);
    };

    const checkAddedPaperListChanges = (addedPapersList, tempAddedPapersList) => {
        if (addedPapersList && tempAddedPapersList) {
            if (JSON.stringify(addedPapersList) !== JSON.stringify(tempAddedPapersList)) {
                if (addedPapersList.categories.length === 0) {
                    dispatch(agendaReplace(addedPapersList))
                } else {
                    props.setShowUpdateButton(true)
                    props.setSaveAddedPaperItemsInRedux(addedPapersList)
                }
            } else {
                props.setShowUpdateButton(false)
            }
        }
    }

    const showCopyForwardDrawer = (selectedItem, selectedType) => {
        // Check if selectedItem has any attachments with shareWith.type === 'all'
        if (selectedType === 'paperItem') {
            const attachments = selectedItem?.attachments || [];
            const shareableAttachments = attachments.filter(attachment =>
                attachment?.shareWith?.type === 'all'
            );

            if (shareableAttachments.length === 0) {
                openNotificationWithIcon('warning', 'No Shareable Attachments', 'This paper doesn\'t have any shareable attachments. Only attachments shared with "all" can be copied and forwarded.', 'bottomLeft');
                return;
            }
        } else if (selectedType === 'attachment') {
            // For individual attachments, check if it's shareable
            if (selectedItem?.shareWith?.type !== 'all') {
                openNotificationWithIcon('warning', 'Attachment Not Shareable', 'This attachment is not shareable. Only attachments shared with "all" can be copied and forwarded.', 'bottomLeft');
                return;
            }
        }

        setSelectedItemToSend(selectedItem)
        setOpenShareForwardDrawer(true)
        setClickedItemType(selectedType)
    };

    const onCloseCopyForwardDrawer = () => {
        setSelectedItemToSend(null)
        setOpenShareForwardDrawer(false)
        setClickedItemType(null)
        setSelectedDate(dayjs().format('YYYY-MM-DD'))
        setExpandedKeys([])
        setSelectedKeysToSendMeeting(null)
        setIsLayer1Visible(true)
    };

    useEffect(() => {
        if (openShareForwardDrawer) {
            setSelectedDate(dayjs().format('YYYY-MM-DD')); // Reset to today when the drawer opens
        }
    }, [openShareForwardDrawer]);

    const reOrderArray = (incommingArray) => {
        return incommingArray.map((single, index) => ({
            ...single,
            order: index + 1
        }))
    }

    const checkSendButtonActive = (clickedItemType, selectedKeysToSendMeeting) => {
        if (clickedItemType === 'attachment') {
            if (selectedKeysToSendMeeting) {
                const keyParts = selectedKeysToSendMeeting.split('-')
                if (keyParts && keyParts.length > 1) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        } else {
            if (selectedKeysToSendMeeting) {
                return false
            } else {
                return true;
            }
        }
    }

    const handleSendButton = () => {
        if (shareForwardScreenRef.current) {
            shareForwardScreenRef.current.triggerSendFunction();
        } else {
            console.log('Ref not available');
        }
    }

    const downloadMeetingMinute = async () => {
            const formData = {"originalDate": meetingCommonInfo.originalDate, "meetingDate": meetingCommonInfo.meetingDate };
            const meetingId = meetingCommonInfo.meetingId;

            await MeetingAPI.downloadMeetingMinutes(
              formData,
              companyId,
              meetingId,
              token
            )
            .then((res) => {
                if (res.status === 200) {
                    const fileType = res.headers['content-type'];
                    const validTypes = [
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/msword',
                    ];

                    if (!validTypes.includes(fileType)) {
                    openNotificationWithIcon(
                        'error',
                        'Abort',
                        `Unsupported file type. Cannot download this file.`,
                        'bottomLeft'
                    );
                    return;
                    }

                    const url = window.URL.createObjectURL(new Blob([res.data], { type: fileType }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${meetingCommonInfo.minute.fileName}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch((err) => {
              if (err.response) {
                openNotificationWithIcon(
                  "error",
                  "Meeting minutes download failed",
                  `${err.response.data.message}`,
                  "bottomLeft"
                );
              } else {
                openNotificationWithIcon(
                  "error",
                  "Meeting minutes download failed",
                  `${err.message}`,
                  "bottomLeft"
                );
              }
            });
    }

    function formatTime(dateTimeString) {
        const date = new Date(dateTimeString);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12;
        const strMinutes = minutes < 10 ? '0' + minutes : minutes;

        return `${hours}:${strMinutes} ${ampm}`;
   }
    const formatDate = (dateTimeString) => {
        // Parse the datetime string to a Date object
        const date = new Date(dateTimeString);

        // Extract the year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');

        // Return the formatted date string
        return `${year}-${month}-${day}`;
    };

    return (
        <>
            <Skeleton loading={isAgendaScreenLoading}>

                <MeetingMinute meetingCommonInfo={meetingCommonInfo} downloadMeetingMinute={downloadMeetingMinute}  currentCompanyInfo={currentCompanyInfo}/>
                                
                <div style={{
                    padding: '8px 12px',
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    marginBottom: 16
                }}>
                    <Flex justify='space-between' align='center'>
                        <span>Added Paper List</span>
                        <Button type="primary" onClick={handleAddPapersButton}
                            disabled={props.actionState === 'view' || props.showUpdateButton || props.openNotificationForEsignatureList}
                        >
                            Add Papers
                        </Button>
                    </Flex>
                </div>
                {contextHolder}
                {props.refreshAgendaItemsList ? <CommonSkeletonLoader itemCount={2} /> : (

                    props.addedPapersList && props.addedPapersList.categories.map((category, categoryIndex) => {
                        return (
                            <div key={categoryIndex} draggable={actionState === 'editPaper'}
                                onDragStart={(e) => {
                                    if (actionState === 'editPaper') {
                                        setDraggedCategoryIndex(categoryIndex)
                                        setSelectedCategoryIndex(categoryIndex)
                                        e.dataTransfer.setData('draggedCategoryIndex', categoryIndex)
                                    }
                                }}
                                onDragOver={(e) => {
                                    if (actionState === 'editPaper') {
                                        e.preventDefault();
                                        setDraggedOverCategoryIndex(categoryIndex)
                                    }
                                }}
                                onDragLeave={() => {
                                    if (actionState === 'editPaper') {
                                        setDraggedOverCategoryIndex(null)
                                    }
                                }}
                                onDrop={(e) => {
                                    if (actionState === 'editPaper') {
                                        e.preventDefault()
                                        const currentDraggedCategoryIndex = e.dataTransfer.getData('draggedCategoryIndex')
                                        const currentDraggedPaperItemIndex = e.dataTransfer.getData('draggedPaperItemIndex');
                                        const draggedIndex = e.dataTransfer.getData('draggedIndex');

                                        // console.log('--------category--------')
                                        // console.log('selected category index :', currentDraggedCategoryIndex)
                                        // console.log('selected paper item index :', currentDraggedPaperItemIndex)
                                        // console.log('selected attachment index :', draggedIndex)
                                        // console.log('selectedAttachmentIndex :', selectedAttachmentIndex)

                                        // console.log('drop category index :', draggedOverCategoryIndex)
                                        // console.log('drop paper item index :', draggedOverPaperItemIndex)
                                        // console.log('drop attachment index :', dropTargetIndex)

                                        if ((selectedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) && (selectedAttachmentIndex !== dropTargetIndex)) {
                                            return;
                                        }

                                        // no category or item or attachment place changed
                                        if ((selectedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) & (draggedIndex == dropTargetIndex)) {
                                            props.setAddedPapersList(props.addedPapersList)
                                            // return;
                                        }

                                        // no category or item changed, but
                                        if ((selectedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) & (dropTargetIndex === null)) {
                                            props.setAddedPapersList(props.addedPapersList)
                                            // return;
                                        }

                                        // no category changed | but item changed | adding new attachment to a empty paper item
                                        if ((selectedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex !== draggedOverPaperItemIndex) && dropTargetIndex === null && draggedIndex?.length !== 0 && draggedOverPaperItemIndex !== null) {
                                            const selectedPaperAttachment = props.addedPapersList.categories[currentDraggedCategoryIndex].items[currentDraggedPaperItemIndex].attachments[draggedIndex]
                                            const initCategoryIndex = props.addedPapersList.categories[currentDraggedCategoryIndex]
                                            const movedFromPaperItem = initCategoryIndex.items[currentDraggedPaperItemIndex]
                                            const movedToPaperItem = initCategoryIndex.items[draggedOverPaperItemIndex]?.attachments

                                            const newMovedFromPaperItem = movedFromPaperItem.attachments.filter(single => (single.isAddedToDB ? single._id : single.id) !== (selectedPaperAttachment.isAddedToDB ? selectedPaperAttachment._id : selectedPaperAttachment.id))
                                            const reOrderedmovedFromAttachmentsArray = reOrderArray(newMovedFromPaperItem)

                                            const newMovedToAttachmentsArray = [...movedToPaperItem, selectedPaperAttachment];
                                            const reOrderedMovedToAttachmentsArray = reOrderArray(newMovedToAttachmentsArray);
                                            const updatedCategories = props.addedPapersList.categories.map((category, categoryIndex) => {
                                                if (categoryIndex == currentDraggedCategoryIndex) {
                                                    return {
                                                        ...category,
                                                        items: category.items.map((item, itemIndex) => {
                                                            if (itemIndex == currentDraggedPaperItemIndex) {
                                                                return {
                                                                    ...item,
                                                                    attachments: reOrderedmovedFromAttachmentsArray,
                                                                };
                                                            } else if (itemIndex == draggedOverPaperItemIndex) {
                                                                return {
                                                                    ...item,
                                                                    attachments: reOrderedMovedToAttachmentsArray,
                                                                };
                                                            }
                                                            return item;
                                                        }),
                                                    };
                                                }
                                                return category;
                                            });
                                            const updatedAddedPapersList = {
                                                ...props.addedPapersList,
                                                categories: updatedCategories,
                                            };
                                            props.setAddedPapersList(updatedAddedPapersList);
                                            checkAddedPaperListChanges(updatedAddedPapersList, props.tempAddedPapersList)
                                            // dispatch(agendaReplace(updatedAddedPapersList));
                                            // props.setShowUpdateButton(JSON.stringify(props.addedPapersList) !== JSON.stringify(updatedAddedPapersList))
                                            return;
                                        }

                                        // Category changed | move paper item into another category.
                                        if ((selectedCategoryIndex !== draggedOverCategoryIndex) && currentDraggedPaperItemIndex?.length > 0 && draggedIndex?.length === 0) {
                                            const selectedPaperItem = props.addedPapersList.categories[currentDraggedCategoryIndex].items[currentDraggedPaperItemIndex]
                                            const movedFromCategory = props.addedPapersList.categories[currentDraggedCategoryIndex]
                                            const movedToCategory = props.addedPapersList.categories[draggedOverCategoryIndex]

                                            const newMovedFromCategory = {
                                                ...movedFromCategory,
                                                items: movedFromCategory.items
                                                    .filter(single => (single?.isAddedToDB ? single._id : single.id) !== (selectedPaperItem?.isAddedToDB ? selectedPaperItem?._id : selectedPaperItem?.id))
                                                    .map((item, index) => ({ ...item, order: index + 1 })),
                                            };

                                            const newOrderForMovedToCategory = movedToCategory?.items?.length + 1;
                                            const updatedMovedToCategory = {
                                                ...movedToCategory,
                                                items: [
                                                    ...movedToCategory.items,
                                                    { ...selectedPaperItem, order: newOrderForMovedToCategory }
                                                ]
                                            }
                                            const updatedCategories = props.addedPapersList.categories.map((category, index) => {
                                                if (index == currentDraggedCategoryIndex) {
                                                    return newMovedFromCategory;
                                                } else if (index === draggedOverCategoryIndex) {
                                                    return updatedMovedToCategory;
                                                }
                                                return category;
                                            });

                                            const updatedAddedPapersList = {
                                                ...props.addedPapersList,
                                                categories: updatedCategories,
                                            };
                                            props.setAddedPapersList(updatedAddedPapersList)
                                            checkAddedPaperListChanges(updatedAddedPapersList, props.tempAddedPapersList)
                                            // dispatch(agendaReplace(updatedAddedPapersList))
                                            return;
                                        }

                                        if ((selectedCategoryIndex !== draggedOverCategoryIndex) && draggedOverPaperItemIndex === null && dropTargetIndex === null) {
                                            return;
                                        }

                                        // category changed | move attachment into another category -> paper item
                                        if ((selectedCategoryIndex !== draggedOverCategoryIndex) && draggedIndex?.length > 0) {
                                            const selectedAttachment = props.addedPapersList.categories[currentDraggedCategoryIndex].items[currentDraggedPaperItemIndex].attachments[draggedIndex];
                                            const movedFromPaperItem = props.addedPapersList.categories[currentDraggedCategoryIndex].items[currentDraggedPaperItemIndex]
                                            const movedToPaperItem = props.addedPapersList.categories[draggedOverCategoryIndex].items[draggedOverPaperItemIndex]

                                            const newMovedFromPaperItemAttachment = movedFromPaperItem?.attachments.filter(single => (single.isAddedToDB ? single._id : single.id) !== (selectedAttachment.isAddedToDB ? selectedAttachment._id : selectedAttachment.id))
                                            const reOrderedMovedFrom = reOrderArray(newMovedFromPaperItemAttachment)

                                            const newMovedToPaperItemAttachments = [...movedToPaperItem.attachments]
                                            if (newMovedToPaperItemAttachments?.length === 0) {
                                                newMovedToPaperItemAttachments.push(selectedAttachment)
                                            } else {
                                                newMovedToPaperItemAttachments.splice(draggedOverPaperItemIndex, 0, selectedAttachment);
                                            }
                                            const reOrderedMovedTo = reOrderArray(newMovedToPaperItemAttachments)

                                            const updatedCategories = props.addedPapersList.categories.map((category, categoryIndex) => {
                                                if (categoryIndex == currentDraggedCategoryIndex) {
                                                    return {
                                                        ...category,
                                                        items: category.items.map((item, itemIndex) => {
                                                            if (itemIndex == currentDraggedPaperItemIndex) {
                                                                return {
                                                                    ...item,
                                                                    attachments: reOrderedMovedFrom,
                                                                };
                                                            }
                                                            return item;
                                                        }),
                                                    };
                                                } else if (categoryIndex == draggedOverCategoryIndex) {
                                                    return {
                                                        ...category,
                                                        items: category.items.map((item, itemIndex) => {
                                                            if (itemIndex == draggedOverPaperItemIndex) {
                                                                return {
                                                                    ...item,
                                                                    attachments: reOrderedMovedTo,
                                                                };
                                                            }
                                                            return item;
                                                        }),
                                                    };
                                                }
                                                return category;
                                            });
                                            const updatedAddedPapersList = {
                                                ...props.addedPapersList,
                                                categories: updatedCategories,
                                            };
                                            props.setAddedPapersList(updatedAddedPapersList);
                                            checkAddedPaperListChanges(updatedAddedPapersList, props.tempAddedPapersList)
                                            // dispatch(agendaReplace(updatedAddedPapersList));
                                            // return;
                                        }

                                        // Only category order changed.
                                        if ((selectedCategoryIndex !== draggedOverCategoryIndex) && currentDraggedPaperItemIndex?.length === 0 && draggedIndex?.length === 0) {
                                            const draggedCategory = props.addedPapersList.categories[currentDraggedCategoryIndex]
                                            const newCategoriesArray = [...props.addedPapersList.categories]
                                            newCategoriesArray.splice(currentDraggedCategoryIndex, 1)
                                            newCategoriesArray.splice(categoryIndex, 0, draggedCategory)

                                            const orderedCategoriesArray = reOrderArray(newCategoriesArray);
                                            props.setAddedPapersList((prevList) => {
                                                const updatedPaperList = {
                                                    ...props.addedPapersList,
                                                    categories: orderedCategoriesArray
                                                }

                                                // dispatch(agendaReplace(updatedPaperList))
                                                checkAddedPaperListChanges(updatedPaperList, props.tempAddedPapersList)
                                                return updatedPaperList
                                            })
                                        }
                                        setDraggedCategoryIndex(null)
                                    }
                                }}
                                onDragEnd={() => {
                                    if (actionState === 'editPaper') {
                                        setDraggedOverCategoryIndex(null)
                                    }
                                }}
                                style={{
                                    border: draggedOverCategoryIndex === categoryIndex ? `1px dashed ${colorPrimary}` : null,
                                    borderRadius: borderRadiusLG,
                                    cursor: actionState === 'editPaper' ? 'grab' : 'default',
                                }}
                            >
                                <Flex
                                    align='center'
                                    justify='space-between'
                                    style={{
                                        padding: '16px 12px',
                                        background: colorBgContainer,
                                        borderRadius: borderRadiusLG,
                                        marginBottom: 8,
                                        fontWeight: 800,
                                        borderLeft: `4px solid ${colorPrimary}`,
                                        borderRight: `0.5px solid ${colorBorder}`,
                                        borderTop: `0.5px solid ${colorBorder}`,
                                        borderBottom: `0.5px solid ${colorBorder}`
                                    }}
                                >
                                    <span>{category.categoryName}</span>
                                </Flex>
                                {
                                    category.items.map((singleItem, categoryItemIndex) => (
                                        <Card
                                            key={categoryItemIndex}
                                            draggable={actionState === 'editPaper'}
                                            onDragStart={(e) => {
                                                if (actionState === 'editPaper') {
                                                    setDraggedPaperItemIndex(categoryItemIndex)
                                                    setSelectedPaperItemIndex(categoryItemIndex)
                                                    e.dataTransfer.setData('draggedPaperItemIndex', categoryItemIndex)
                                                    setSelectedTagToMove('paperItem')
                                                }
                                            }}
                                            onDragOver={(e) => {
                                                if (actionState === 'editPaper') {
                                                    e.preventDefault();
                                                    setDraggedOverPaperItemIndex(categoryItemIndex)
                                                }
                                            }}
                                            onDragLeave={(e) => {
                                                if (actionState === 'editPaper') {
                                                    setDraggedOverPaperItemIndex(null)
                                                    setSelectedTagToMove(null)
                                                }
                                            }}
                                            onDrop={(e) => {
                                                if (actionState === 'editPaper') {
                                                    e.preventDefault();
                                                    const currentDraggedCategoryIndex = e.dataTransfer.getData('draggedCategoryIndex');
                                                    const currentDraggedPaperItemIndex = e.dataTransfer.getData('draggedPaperItemIndex');
                                                    const draggedIndex = e.dataTransfer.getData('draggedIndex');
                                                    console.log('--------paper item--------')

                                                    if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) && (draggedIndex == dropTargetIndex)) {
                                                        return;
                                                    }
                                                    if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) && (draggedIndex !== dropTargetIndex)) {
                                                        return;
                                                    }
                                                    if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex !== draggedOverPaperItemIndex) && (draggedIndex == dropTargetIndex)) {
                                                        return;
                                                    }

                                                    // paper item changed
                                                    if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && draggedIndex?.length === 0) {
                                                        const draggedPaperItem = category.items[currentDraggedPaperItemIndex]
                                                        const newPaperItemsArray = [...category.items]
                                                        newPaperItemsArray.splice(currentDraggedPaperItemIndex, 1)
                                                        newPaperItemsArray.splice(categoryItemIndex, 0, draggedPaperItem)

                                                        const orderedPaperItemsArray = reOrderArray(newPaperItemsArray);

                                                        props.setAddedPapersList((prevList) => {
                                                            const currentList = { ...prevList }
                                                            const extractedCategory = currentList.categories[currentDraggedCategoryIndex]
                                                            const updatedCategory = {
                                                                ...extractedCategory,
                                                                items: orderedPaperItemsArray
                                                            }
                                                            currentList.categories = currentList.categories.map((category) => {
                                                                if ((category.isAddedToDB ? category._id : category.id) === (extractedCategory.isAddedToDB ? extractedCategory._id : extractedCategory.id)) {
                                                                    return updatedCategory;
                                                                }
                                                                return category
                                                            })
                                                            // dispatch(agendaReplace(currentList))
                                                            checkAddedPaperListChanges(currentList, props.tempAddedPapersList)
                                                            return currentList;
                                                        })
                                                    }
                                                    // }
                                                    setDraggedOverPaperItemIndex(null)
                                                    setSelectedTagToMove(null)
                                                }
                                            }}
                                            onDragEnd={() => {
                                                if (actionState === 'editPaper') {
                                                    setSelectedTagToMove(null)
                                                    setDraggedOverPaperItemIndex(null)
                                                }
                                            }}
                                            title={
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-start'
                                                    }}
                                                >
                                                    <Flex vertical gap={4} style={{minWidth:0, flex: 1}}>
                                                        <span style={{display:'block',textWrap:'wrap',minWidth:0,color: colorTextHeading,fontWeight:600}}>{singleItem.name}</span>
                                                        <Flex align='center' gap={8} wrap='wrap' style={{minWidth:0}}>
                                                            {
                                                                (singleItem.order !== undefined && singleItem.order !== null) && (
                                                                    <Tag
                                                                        bordered={false}
                                                                        color='default'
                                                                        style={{
                                                                            width: 'fit-content',
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            color: colorText,
                                                                            margin: 0
                                                                        }}
                                                                    >
                                                                        Paper No: {singleItem.order}
                                                                    </Tag>
                                                                )
                                                            }
                                                        </Flex>
                                                    </Flex>
                                                    <Flex justify='space-between' align='center' gap={10}>
                                                        <Badge status='default' text={singleItem.status === 'not shared' ?
                                                            "Unpublish" : "Publish"
                                                        } />
                                                        <Tooltip title="View">
                                                            <Button
                                                                icon={<EyeOutlined />}
                                                                onClick={() => {
                                                                    // handlePDFAnnotation(doc)
                                                                    handleViewAddedPaper(category._id, singleItem._id)
                                                                }}
                                                                type='primary'
                                                            />
                                                        </Tooltip>
                                                        {
                                                            actionState !== 'view' && (
                                                                <Tooltip title="Edit">
                                                                    <Button
                                                                        icon={<EditOutlined  />}
                                                                        onClick={() => {
                                                                            handleEditAddedPaper(category._id, singleItem)
                                                                            // handlePDFAnnotation(doc)
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            )
                                                        }
                                                        {/* {
                                                            actionState === 'editPaper' && (
                                                                <Tooltip title="Copy & Forward">
                                                                    <Button
                                                                        icon={<CopyOutlined />}
                                                                        onClick={() => {
                                                                            showCopyForwardDrawer(singleItem, 'paperItem')
                                                                            // handlePDFAnnotation(doc)
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            )
                                                        } */}
                                                        {
                                                             actionState !== 'view' && (
                                                                <Popconfirm
                                                                    title="Do you want to remove the paper item?"
                                                                    onConfirm={() => {
                                                                        handleRemoveAddedPaper(category._id, singleItem);
                                                                        handlePopconfirmClose(singleItem._id);
                                                                    }}
                                                                    onCancel={() => {
                                                                        openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft');
                                                                        handlePopconfirmClose(singleItem._id);
                                                                    }
                                                                    }
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                >
                                                                    <Tooltip title="Delete">
                                                                        <Button
                                                                            icon={<DeleteOutlined />}
                                                                            onClick={(e) => handlePopconfirmOpen(e)}
                                                                            danger
                                                                        />
                                                                    </Tooltip>
                                                            </Popconfirm>
                                                            )
                                                        }
                                                        {/* <Dropdown
                                                            menu={{
                                                                items: getItems(category._id, singleItem._id, singleItem)
                                                            }}
                                                            disabled={props.openNotificationForEsignatureList || props.showUpdateButton}
                                                        >
                                                            <Button type='text' icon={<MoreOutlined />} />
                                                        </Dropdown> */}
                                                    </Flex>
                                                </div>
                                            }
                                            bordered={false}
                                            size='small'
                                            style={{
                                                borderRight: draggedOverPaperItemIndex === categoryItemIndex ? `1px dashed ${colorWarning}` : `0.5px solid ${colorBorder}`,
                                                borderTop: draggedOverPaperItemIndex === categoryItemIndex ? `1px dashed ${colorWarning}` : `0.5px solid ${colorBorder}`,
                                                borderBottom: draggedOverPaperItemIndex === categoryItemIndex ? `1px dashed ${colorWarning}` : `0.5px solid ${colorBorder}`,
                                                borderLeft: `4px solid ${colorWarning}`,
                                                marginBottom: '16px',
                                                cursor: actionState === 'editPaper' ? 'grab' : 'default',
                                            }}
                                        >
                                            {
                                                singleItem?.attachments?.length > 0 ? (
                                                    <List
                                                        dataSource={singleItem.attachments}
                                                        renderItem={(doc, docIndex) => (
                                                            <List.Item
                                                                key={docIndex}
                                                                draggable={actionState === 'editPaper'}
                                                                onDragStart={(e) => {
                                                                    if (actionState === 'editPaper') {
                                                                        setSelectedAttachmentIndex(docIndex);
                                                                        e.dataTransfer.setData('draggedIndex', docIndex);
                                                                    }
                                                                }}
                                                                onDragOver={(e) => {
                                                                    if (actionState === 'editPaper') {
                                                                        e.preventDefault();
                                                                        setDropTargetIndex(docIndex);
                                                                    }
                                                                }}
                                                                onDragLeave={(e) => {
                                                                    if (actionState === 'editPaper') {
                                                                        setDropTargetIndex(null)
                                                                        setSelectedTagToMove(null)
                                                                    }
                                                                }}
                                                                onDrop={(e) => {
                                                                    if (actionState === 'editPaper') {
                                                                        e.preventDefault();
                                                                        const currentDraggedCategoryIndex = e.dataTransfer.getData('draggedCategoryIndex');
                                                                        const currentDraggedPaperItemIndex = e.dataTransfer.getData('draggedPaperItemIndex');
                                                                        const draggedIndex = e.dataTransfer.getData('draggedIndex');
                                                                        console.log('--------attachment--------')

                                                                        if (!currentDraggedCategoryIndex || !currentDraggedPaperItemIndex) {
                                                                            return;
                                                                        }

                                                                        // allow change order | attachment
                                                                        if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && (currentDraggedPaperItemIndex == draggedOverPaperItemIndex) && (selectedAttachmentIndex !== dropTargetIndex)) {
                                                                            const draggedAttachment = singleItem.attachments[draggedIndex];
                                                                            const newAttachmentsArray = [...singleItem.attachments];
                                                                            newAttachmentsArray.splice(draggedIndex, 1);
                                                                            newAttachmentsArray.splice(docIndex, 0, draggedAttachment);
                                                                            const orderedArray = reOrderArray(newAttachmentsArray)

                                                                            props.setAddedPapersList((prevList) => {
                                                                                const currentList = { ...prevList };
                                                                                const extractedCategory = currentList.categories[currentDraggedCategoryIndex]
                                                                                const extractedPaperItem = extractedCategory.items[currentDraggedPaperItemIndex]

                                                                                const updatedCategory = {
                                                                                    ...extractedCategory,
                                                                                    items: extractedCategory.items.map((item) => {
                                                                                        if ((item.isAddedToDB ? item._id : item.id) === (extractedPaperItem.isAddedToDB ? extractedPaperItem._id : extractedPaperItem.id)) {
                                                                                            return {
                                                                                                ...item,
                                                                                                attachments: orderedArray
                                                                                            }
                                                                                        }
                                                                                        return item;
                                                                                    })
                                                                                }

                                                                                currentList.categories = currentList.categories.map((category) => {
                                                                                    if ((category.isAddedToDB ? category._id : category.id) === (extractedCategory.isAddedToDB ? extractedCategory._id : extractedCategory.id)) {
                                                                                        return updatedCategory;
                                                                                    }
                                                                                    return category
                                                                                })
                                                                                checkAddedPaperListChanges(currentList, props.tempAddedPapersList)
                                                                                return currentList;
                                                                            })
                                                                        }

                                                                        // attachment moved. | accross paper items | recorded within attachment section
                                                                        if ((currentDraggedCategoryIndex == draggedOverCategoryIndex) && (selectedPaperItemIndex !== draggedOverPaperItemIndex) && draggedIndex?.length !== 0) {
                                                                            const selectedPaperAttachment = props.addedPapersList.categories[currentDraggedCategoryIndex].items[currentDraggedPaperItemIndex].attachments[draggedIndex]
                                                                            const movedFromPaperItem = category.items[currentDraggedPaperItemIndex]
                                                                            const movedToPaperItem = [...category.items[draggedOverPaperItemIndex].attachments]
                                                                            const newMovedFromPaperItem = movedFromPaperItem.attachments.filter(single => (single.isAddedToDB ? single._id : single.id) !== (selectedPaperAttachment.isAddedToDB ? selectedPaperAttachment._id : selectedPaperAttachment.id))
                                                                            const reOrderedmovedFromAttachmentsArray = reOrderArray(newMovedFromPaperItem)

                                                                            movedToPaperItem.splice(docIndex, 0, selectedPaperAttachment)
                                                                            const reOrderedmovedToAttachmentsArray = reOrderArray(movedToPaperItem)

                                                                            const updatedCategories = props.addedPapersList.categories.map((categoryItem, categoryIndex) => {
                                                                                if (categoryIndex == currentDraggedCategoryIndex) {
                                                                                    return {
                                                                                        ...categoryItem,
                                                                                        items: categoryItem.items.map((item, itemIndex) => {
                                                                                            if (itemIndex == currentDraggedPaperItemIndex) {
                                                                                                return {
                                                                                                    ...item,
                                                                                                    attachments: reOrderedmovedFromAttachmentsArray
                                                                                                }
                                                                                            } else if (itemIndex == draggedOverPaperItemIndex) {
                                                                                                return {
                                                                                                    ...item,
                                                                                                    attachments: reOrderedmovedToAttachmentsArray
                                                                                                }
                                                                                            }
                                                                                            return item;
                                                                                        })
                                                                                    }
                                                                                }
                                                                                return categoryItem;
                                                                            })
                                                                            const newAddedPapersList = {
                                                                                ...props.addedPapersList,
                                                                                categories: updatedCategories,
                                                                            };
                                                                            props.setAddedPapersList(newAddedPapersList);
                                                                            checkAddedPaperListChanges(newAddedPapersList, props.tempAddedPapersList)
                                                                            // dispatch(agendaReplace(newAddedPapersList));
                                                                            return;
                                                                        }

                                                                        setDraggedOverCategoryIndex(null)
                                                                        setSelectedTagToMove(null)
                                                                        setDraggedOverPaperItemIndex(null)
                                                                        setDropTargetIndex(null);
                                                                    }
                                                                }}

                                                                onDragEnd={() => {
                                                                    if (actionState === 'editPaper') {
                                                                        setDraggedOverCategoryIndex(null)
                                                                        setSelectedTagToMove(null)
                                                                        setDraggedOverPaperItemIndex(null)
                                                                        setDropTargetIndex(null);
                                                                    }
                                                                }}
                                                                style={{
                                                                    cursor: actionState === 'editPaper' ? 'grab' : 'default',
                                                                    border: dropTargetIndex === docIndex ? `1px dashed ${colorBorder}` : `null`,
                                                                    borderRadius: borderRadiusLG
                                                                }}
                                                            >
                                                                <div style={{ width: '100%' }}>
                                                                    <Flex vertical gap={12}>
                                                                        <Flex justify='space-between' align='center'>
                                                                            <Flex justify='flex-start' align='center' gap={24}>
                                                                                {renderVotedIcon(doc)}

                                                                                <Flex vertical={true}>
                                                                                    <Flex align="center" gap={8}>
                                                                                        <Text style={{'textWrap':'wrap'}} strong>{doc.name}</Text>
                                                                                        {renderAnnotationStatus(doc)}
                                                                                        {renderAnnotationCounts(doc.annotation)}
                                                                                    </Flex>
                                                                                    {doc?.voting?.isEnabled && (
                                                                                        <SingleVoteRender
                                                                                            docVoteData={doc.voting}
                                                                                            colorPrimary={colorPrimary}
                                                                                            colorWarning={colorWarning}
                                                                                            colorError={colorError}
                                                                                            borderRadiusLG={borderRadiusLG}
                                                                                        />
                                                                                    )}
                                                                                    <Text type='secondary' >{doc.comment}</Text>
                                                                                </Flex>
                                                                            </Flex>

                                                                            <Flex justify="flex-end" align="center" gap={12}>
                                                                                {
                                                                                    actionState === "view" &&(
                                                                                        <Tooltip title={dayjs(meetingCommonInfo?.meetingdateAndTime).isBefore(dayjs()) ? "View PDF": "View PDF"}>
                                                                                            <Button
                                                                                                icon={<FilePdfOutlined />}
                                                                                                onClick={() => {
                                                                                                    handlePDFAnnotation(doc)
                                                                                                }}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    ["editPaper"].includes(actionState) && (
                                                                                        <Tooltip title="Request e-Signature">
                                                                                            <Button
                                                                                                icon={<UnorderedListOutlined />}
                                                                                                disabled
                                                                                                // onClick={() => showCopyForwardDrawer(doc, "attachment")}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    (actionState === "view" ||
                                                                                        (actionState === "editPaper" &&
                                                                                        mapESignatureData(doc)?.length > 0)) &&
                                                                                        (role.some((r) => r.roleName === "Secretary") ||
                                                                                        role.some((r) => r.roleName === "Assistant Secretary")) && (
                                                                                            <Tooltip title="e-Signatures">
                                                                                                <Button
                                                                                                    icon={<UnorderedListOutlined />}
                                                                                                    disabled
                                                                                                />
                                                                                            </Tooltip>
                                                                                        )
                                                                                }
                                                                                {/* {
                                                                                    actionState === "editPaper" &&
                                                                                        (doc?.shareWith?.type === 'all') &&
                                                                                        (role.some((r) => r.roleName === "Secretary") ||
                                                                                        role.some((r) => r.roleName === "Assistant Secretary")) && (
                                                                                            <Tooltip title="Copy & Forward">
                                                                                                <Button
                                                                                                    icon={<CopyOutlined />}
                                                                                                    onClick={() => showCopyForwardDrawer(doc, "attachment")}
                                                                                                />
                                                                                            </Tooltip>
                                                                                        )
                                                                                } */}
                                                                                {doc?.voting?.isEnabled && actionState === 'view' && (
                                                                                    <Dropdown
                                                                                        menu={options(doc, category._id, singleItem._id)}
                                                                                        disabled={!dayjs().isBefore(
                                                                                            doc?.voting?.end?.type === 'after'
                                                                                                ? doc?.voting?.end?.date
                                                                                                : doc?.voting?.end?.customDate
                                                                                        )}
                                                                                    >
                                                                                        <Button type="default"> Voting </Button>
                                                                                    </Dropdown>
                                                                                )}
                                                                                {/* {['editPaper', 'view'].includes(actionState) && (
                                                                                    <Dropdown
                                                                                        menu={{
                                                                                            items: attachmentOptions(doc, (singleItem.isAddedToDB ? singleItem._id : singleItem.id), category._id),
                                                                                        }}
                                                                                        trigger={['click']}
                                                                                        disabled={props.openNotificationForEsignatureList || props.showUpdateButton}
                                                                                    >
                                                                                        <Button type="text" icon={<MoreOutlined />} />
                                                                                    </Dropdown>
                                                                                )} */}
                                                                            </Flex>
                                                                        </Flex>
                                                                        {renderIncommingSignatureRequest(doc, singleItem._id)}
                                                                    </Flex>
                                                                </div>
                                                            </List.Item>
                                                        )}
                                                    ></List>
                                                ) : null
                                            }
                                        </Card>
                                    ))
                                }
                            </div>
                        )
                    })

                )}


                <Drawer
                    size='default'
                    title="Members List"
                    onClose={() => {
                        onCloseMemberListDrawer()
                    }}
                    open={openMemberListForSignature}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={onCloseMemberListDrawer}>
                                Cancel
                            </Button>

                            {agendaItemOpenState !== 'view' &&
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        handleSignatureListSave()
                                    }}
                                >
                                    Send
                                </Button>}
                        </Flex>
                    ]
                    }
                >
                    <ShareList
                        selectedPaperItemID={selectedPaperItemID}
                        selectedAttachmentID={selectedAttachmentID}
                        openMemberListForSignature={openMemberListForSignature}
                        setSignatureInviteList={setSignatureInviteList}
                        signatureInviteList={signatureInviteList}
                        selectedCategoryId={selectedCategory}
                    />
                </Drawer>

                {/* papers drawer */}
                <Drawer
                    size={'large'}
                    width={'50%'}
                    title={agendaItemOpenState === 'add' ? "Add Papers" : agendaItemOpenState === 'edit' ? "Edit Papers" : "View Papers"}
                    onClose={() => {
                        onClose()
                        setAgendaItemOpenState('add');
                        setShowVoteResult(false);
                        // setSelectedPaper(null);
                    }}
                    open={openAddNewAgendaDrawer}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={onClose}>
                                Cancel
                            </Button>

                            {agendaItemOpenState !== 'view' &&
                                <Button
                                    type="primary"
                                    onClick={handleAgendaItemSave}
                                >
                                    {agendaItemOpenState === 'add' ? "Save" : "Update"}
                                </Button>}
                        </Flex>
                    ]
                    }
                >
                    <AddAgendaItem
                        ref={agendaScreenRef}
                        attachement={attachement}
                        setAttachement={setAttachement}
                        allowVoting={allowVoting}
                        setAllowVoting={setAllowVoting}
                        setVotingData={setVotingData}
                        votingData={votingData}
                        openAddNewAgendaDrawer={openAddNewAgendaDrawer}
                        agendaItemOpenState={agendaItemOpenState}
                        showVoteResult={showVoteResult}
                        setShowVoteResult={setShowVoteResult}
                        documentArray={documentArray}
                        setDocumentArray={setDocumentArray}
                        selectedPaper={selectedPaper}
                        setSelectedPaper={setSelectedPaper}
                        selectedCategory={selectedCategory}
                        documentOpenState={documentOpenState}
                        setDocumentOpenState={setDocumentOpenState}
                        isAddDisable = {isAddDisable}
                        setIsAddDisable = {setIsAddDisable}
                        uploadFileDetails = {uploadFileDetails}
                        setUploadFileDetails = {setUploadFileDetails}
                    />
                </Drawer>
                <Drawer
                    title="Members"
                    onClose={onCloseESignatureList}
                    open={openESignatureList}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button >
                                Cancel
                            </Button>
                            <Button type="primary" >
                                Send
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    <Flex align='center' justify='space-between' style={{ marginBottom: 16 }} gap={12}>
                        <Input
                            size='medium'
                            placeholder="Type Group Name"
                        />
                    </Flex>
                    <Flex align='center' justify='space-between' style={{ marginBottom: 16 }} gap={12}>
                        <Input
                            size='medium'
                            placeholder="Search by name"
                            prefix={<SearchOutlined />}
                        />
                    </Flex>
                    <Flex key={1} align='center' justify='flex-start' gap={8} style={nameCardContainerStyle}>
                        <Flex align='center' justify='center'>
                            <Avatar size={36} style={avatarStyle}>
                                A
                            </Avatar>
                        </Flex>
                        <Flex align='flex-start' justify='flex-start' vertical={true} style={{ width: '100%' }}>
                            <Flex align='center'>
                                <span>Name</span>
                            </Flex>
                            <Flex align='center'>
                                <span style={chatSummeryStyle}>Designation</span>
                            </Flex>
                        </Flex>
                        <Flex align='center' justify='center'>
                            <Checkbox
                                style={checkBoxStyle}
                            />
                        </Flex>
                    </Flex>
                </Drawer>
                <Drawer
                    title="Copy & Forward Papers"
                    onClose={onCloseCopyForwardDrawer} open={openShareForwardDrawer}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={() => onCloseCopyForwardDrawer()}>
                                Cancel
                            </Button>
                            <Button type="primary"
                                disabled={checkSendButtonActive(clickedItemType, selectedKeysToSendMeeting)}
                                onClick={() => handleSendButton()}
                                loading={isLoadingWhileSending}
                            >
                                Share
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    <ShareForwordPaper
                        ref={shareForwardScreenRef}
                        clickedItemType={clickedItemType}
                        openShareForwardDrawer={openShareForwardDrawer}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        selectedItemToSend={selectedItemToSend}
                        expandedKeys={expandedKeys}
                        setExpandedKeys={setExpandedKeys}
                        selectedKeysToSendMeeting={selectedKeysToSendMeeting}
                        setSelectedKeysToSendMeeting={setSelectedKeysToSendMeeting}
                        isLayer1Visible={isLayer1Visible}
                        setIsLayer1Visible={setIsLayer1Visible}
                        shareForwardDrawerLoading={shareForwardDrawerLoading}
                        setShareForwardDrawerLoading={setShareForwardDrawerLoading}
                        onCloseCopyForwardDrawer={onCloseCopyForwardDrawer}
                        isLoadingWhileSending={isLoadingWhileSending}
                        setIsLoadingWhileSending={setIsLoadingWhileSending}
                    />
                </Drawer>

                {/* Annotation Modal */}
                <AnnotationModal
                    visible={annotationModalVisible}
                    annotationUrl={currentAnnotationUrl}
                    onClose={() => {
                        setAnnotationModalVisible(false);
                        setCurrentAnnotationUrl(null);
                        setCurrentAnnotationTitle("PDF Annotation");
                    }}
                    title={currentAnnotationTitle}
                    height="95vh"
                />
            </Skeleton>
        </>
    )
}
